import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { BM_ROLES } from "@/lib/constants";
import { AlertTriangle, X } from "lucide-react";

export default function GoogleStatusAlert() {
  const { user } = useAuth();
  const [bad, setBad] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user || !BM_ROLES.includes(user.role)) return undefined;
    let stop = false;
    const check = () => api.get("/google/status")
      .then((r) => {
        if (stop) return;
        if (!r.data.connected) setBad("disconnected");
        else if (r.data.valid === false) setBad("expired");
        else setBad(null);
      })
      .catch(() => {});
    check();
    const t = setInterval(check, 300000);
    return () => { stop = true; clearInterval(t); };
  }, [user]);

  if (!bad || dismissed) return null;
  return (
    <div data-testid="google-status-alert"
         className="mb-4 flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-800">
      <AlertTriangle className="w-4 h-4 mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        {bad === "disconnected"
          ? "Google (Gmail/Drive) n'est pas connecté — les emails de baux et d'invitations ne partiront pas depuis Gmail."
          : "La connexion Google (Gmail/Drive) a expiré — reconnectez-la pour que les emails et l'archivage Drive fonctionnent."}
        {" "}
        <Link to="/baux" className="font-semibold underline" data-testid="google-status-cta">Gérer la connexion</Link>
      </div>
      <button onClick={() => setDismissed(true)} data-testid="google-status-dismiss"
              className="text-amber-500 hover:text-amber-700 transition-colors" title="Masquer">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
